import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="order-item-pricing"
//
// Calculates order item pricing from qty, unit amount, and discount:
//   Gross Amount = Qty × Unit Amount
//   Total Amount = Gross Amount - Discount
//
// For Voucher::Pack: parses qty and unit amount from the selected pack option.
// For other types: auto-fills price from product selection.
export default class extends Controller {
  static targets = ["product", "quantity", "unitAmount", "grossAmount", "discount", "price"]

  connect() {
    if (this.hasPriceTarget && this.hasQuantityTarget) {
      this.calculate()
    }
  }

  productChanged() {
    if (!this.hasProductTarget) return
    const selected = this.productTarget.selectedOptions[0]
    if (!selected) return

    const text = selected.text

    // Try to parse voucher pack format: "Name - N codes @ $X each (Total: $Y)"
    const qtyMatch = text.match(/(\d+) codes/)
    const amtMatch = text.match(/@ \$([0-9,.]+) each/)

    if (qtyMatch && amtMatch) {
      this.quantityTarget.value = parseInt(qtyMatch[1])
      this.unitAmountTarget.value = parseFloat(amtMatch[1].replace(/,/g, ''))
      if (this.hasDiscountTarget) this.discountTarget.value = ''
      this.calculate()
    } else {
      // Fallback: extract price for non-pack products
      const priceMatch = text.match(/\$([0-9,.]+)/)
      if (priceMatch && this.hasPriceTarget) {
        this.priceTarget.value = parseFloat(priceMatch[1].replace(/,/g, ''))
      }
    }
  }

  // Sync from voucher pack form fields (amount per code + number of codes)
  syncFromPack() {
    const amountField = document.getElementById('voucher_pack_amount')
    const numberField = document.getElementById('voucher_pack_number')
    if (amountField && numberField && this.hasUnitAmountTarget && this.hasQuantityTarget) {
      this.unitAmountTarget.value = amountField.value
      this.quantityTarget.value = numberField.value
      this.calculate()
    }
  }

  calculate() {
    if (!this.hasQuantityTarget || !this.hasUnitAmountTarget || !this.hasPriceTarget) return

    const qty = parseFloat(this.quantityTarget.value) || 0
    const unitAmount = parseFloat(this.unitAmountTarget.value) || 0
    const discount = this.hasDiscountTarget ? (parseFloat(this.discountTarget.value) || 0) : 0

    const gross = qty * unitAmount
    const total = gross - discount

    if (this.hasGrossAmountTarget) {
      this.grossAmountTarget.value = gross.toFixed(2)
    }
    this.priceTarget.value = total.toFixed(2)
  }
}
